import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const getSize = (size, scale = 1) => {
    let rem = 1;
    switch (size) {
        case 'sm':
            rem = 3.25;
            break;
        case 'md':
            rem = 4;
            break;
        case 'lg':
            rem = 5;
            break;
        default:
            break;
    }
    return `${scale * rem}rem`;
};
const Avatar = styled.img `
	width: ${p => getSize(p.Size)};
	height: ${p => getSize(p.Size)};
	object-fit: cover;
	position: absolute;
	top: ${p => p.Top};
	animation: slide-in 0.4s ease;
	left: ${p => p.Left};
	transform: translateY(-75%);
	border-radius: ${p => {
    if (p.Circle)
        return '100rem';
    if (typeof p.Round === 'number')
        return `${p.Round}px`;
    return '1.5rem';
}};
	border: solid 6px ${p => p.bgColor};

	@keyframes slide-in {
		from {
			left: 0;
			opacity: 0.5;
		}
		to {
			left: ${p => p.Left};
			opacity: 1;
		}
	}
`;
const CardAvatar = (props) => {
    const { className, size, bgColor, top, left, corners } = props;
    const imgProps = Object.assign(Object.assign({}, props), { children: null });
    return (React.createElement(Avatar, Object.assign({ className: `corn-card-avatar ${className || ''}` }, imgProps, { Size: size, bgColor: bgColor, Top: top, Left: left, Round: typeof corners === 'number' ? corners : corners === 'round', Circle: corners === 'circle' })));
};
CardAvatar.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    bgColor: PropTypes.string,
    top: PropTypes.string,
    left: PropTypes.string,
    corners: PropTypes.oneOfType([
        PropTypes.oneOf(['normal', 'round', 'circle']),
        PropTypes.number
    ])
};
CardAvatar.defaultProps = {
    size: 'md',
    bgColor: '#ddd',
    top: '50%',
    left: '8%',
    corners: 'round'
};
export default CardAvatar;
